<template>
    <v-layout class="main-carousel-slider-block">
        <v-carousel
            :show-arrows="false"
            cycle
            height="auto"
            class="main-carousel-slider"
        >
            <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item"
                             v-for="(item, key) in items"
                             :key="key"
            >
                <v-flex d-flex class="main-carousel-slider-item-content">
                    <img v-if="typeof(item.img) == 'string'"
                         :src="item.img"
                    />
                    <img v-if="Array.isArray(item.img)"
                         v-for="(img, imgKey) in item.img"
                         :key="imgKey"
                         :src="img"
                    />
                    <v-flex class="main-carousel-slider-text" v-html="item.text"></v-flex>
                </v-flex>
            </v-carousel-item>
        </v-carousel>
    </v-layout>
</template>
<script>
export default {
    props: ['items'],
    data: () => ({}),
}
</script>
<style lang="scss">
.main-carousel-slider-block {
    margin-bottom: 60px;
    position: relative;
    height: 100px;
}

.main-carousel-slider {
    width: 450px;
}

.main-carousel-slider img {
    max-height: 50px;
}

.main-carousel-slider-text {
    min-width: 300px;
    font-size: 20px;
    line-height: 20px;
    font-weight: bold;
    padding-left: 15px;
}

.main-carousel-slider.v-carousel {
    box-shadow: none;
    margin: 0 auto;
}

.main-carousel-slider .v-carousel__controls {
    position: relative;
    padding: 35px;
    background: none;
}

.main-carousel-slider .v-btn .v-btn__content .v-icon {
    font-size: 15px;
    color: #BDBDBD;
    opacity: 1;
}

.main-carousel-slider .v-carousel__prev, .main-carousel-slider .v-carousel__next {
    display: none;
}

.main-carousel-slider .v-btn:before {
    display: none;
}

.main-carousel-slider .v-btn.v-btn--active .v-btn__content .v-icon {
    color: #000000;
}

.main-carousel-slider .v-btn:hover .v-icon {
    -webkit-text-stroke: 1px #000;
}

.main-carousel-slider .v-btn--icon.v-btn--small {
    width: 18px;
}

.main-carousel-slider .main-carousel-slider-item-content {
    align-items: center;
}

.main-carousel-slider-block .v-window__container .v-window-item .v-responsive__content > div {
    align-items: center;
    justify-content: center;
}

.main-carousel-slider .v-responsive .v-image .v-carousel__item {
    height: auto !important;
}

@media screen and (max-width: 600px) {
    .main-carousel-slider-block {
        margin-bottom: 30px;
        height: 100px;
        margin-right: 15px;
        margin-left: 15px;
    }

    .main-carousel-slider .v-responsive .v-image .v-carousel__item {
        height: fit-content !important;
    }

    .main-carousel-slider {
        width: 100%;
        height: fit-content !important;
    }

    .main-carousel-slider .v-responsive.v-image.v-carousel__item {
        height: fit-content !important;
    }

    .main-carousel-slider img {
        max-width: 30px;
    }
    .main-carousel-slider-text {
        font-size: 16px;
        -webkit-text-stroke: 0px;
        max-width: 200px;
        font-weight: bold;
    }
}

.v-window-item .main-carousel-slider-item {
    height: 60px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/InfoCarousel.vue